module.exports = __webpack_public_path__ + "img/managed.373169c.png";